// Generated by https://quicktype.io
//
// To change quicktype's target language, run command:
//
//   "Set quicktype target language"

import { Dictionary } from 'src/app/core/model/dictionary';
import { Organization } from 'src/app/core/model/organization';
import { Address } from 'src/app/member/model/member';
import { CommunityProviderProgramIdentifier } from 'src/app/community/model/community_provider_program_identifier';

export class CommunityProviderSearchResult implements CommunityProviders
{
    public data: CommunityProvider[];
    public total: number;
    public geocode: Geocode;
}
export interface CommunityProviders
{
    data: CommunityProvider[];
    total: number;
}

export interface CommunityProvider
{
    id: number;
    address: Address;
    version: number;
    organization: Organization;
    name: string;
    description: string;
    eligibility: string;
    lastModifiedOn: null;
    cost: string;
    languages: Dictionary[];
    serviceCategory: ServiceCategory;
    openingTimes: OpeningTime[];
    channel: Channel | null;
    distance: number;
    referralEmail: string;
    acceptingDisabledPatients: boolean;
    acceptingElectronicReferrals: boolean;
    acceptingNewPatients: boolean;
    acceptingSelfReferrals: boolean;
    lgbtq: boolean;
    alias: string;
    alertDescription: string;
    applicationProcess: string;
    capacity: string;
    documentationRequired: string;
    areaServedCities: Dictionary[];
    areaServedCounties: Dictionary[];
    areaServedZipCodes: Dictionary[];
    incomeRequirements: Dictionary[];
    paymentMethods: Dictionary[];
    licenses: Dictionary[];
    targetedDemographics: Dictionary[];
    targetedPopulations: Dictionary[];
    providerTaxonomies: Dictionary[];
    resourceStatus: Dictionary;
    submittingOrganization: Organization;
    otherIdentifiers: CommunityProviderProgramIdentifier[];
    waitTimes: WaitTime[];
    websites: Website[];
    directoryManagerName: string;
    directoryManagerEmail: string;
    directoryManagerNotificationPreference: string;
    ableToConductScreenings: boolean;
    informationalOnly: boolean;
    // Calculated properties below
    formattedAddress: string;
    serviceTypeName: string;
    serviceCategoryName: string;
    languagesName: string;
    taxonomiesName: string;
    phoneNumber: string;
    faxNumber: string;
    url: string;
    email: string;
    licensesName: string;
    targetedPopulationsName: string;
    targetedDemographicsName: string;
    providerTaxonomiesName: string;
    areaServedCitiesName: string;
    areaServedCountiesName: string;
    areaServedZipCodesName: string;
    incomeRequirementsName: string;
    paymentMethodsName: string;
    resourceStatusName: string;
}

export interface OpeningTime
{
    id: number;
    day: string;
    version: number;
    from: string;
    to: string;
    // Caculated properties
    sort: number;
    fromDate: Date;
    toDate: Date;
}

export interface ServiceCategory
{
    id: number;
    name: string;
    active: boolean;
    serviceType: Dictionary;
    lastModifiedBy: string;
    lastModifiedDate: string;
    version: number;
}

export interface Geocode
{
    geocodeId: number;
    latitude: number;
    longitude: number;
    city: string;
    state: string;
    country: string;
    county: string;
    locality: string;
    streetNumber: string;
    street: string;
    postalCode: string;
}

export interface Channel
{
    id: number;
    name: string;
    description: string;
    comments: null;
    createdBy: string;
    createdOn: string;
    lastModifiedBy: string;
    lastModifiedOn: string;
    status: string;
    active: boolean;
    version: number;
    leader: string;
    leaderId: number;
    leaderUserName: string;
    statistics: Statistics;
    goals: any[];
    ruleSets: any[];
    groups: any[];
    users: number[];
    bpmId: string;
    bpmKey: string;
    bpmName: string;
    deployedBpmId: string;
    deployedBpmKey: string;
    appId: string;
    category: string;
    categoryId: number;
    modelId: null;
    channelZip: null;
    program: Program;
    copyChannelId: null;
}

export interface Statistics
{
    id: number;
    version: number;
    openCases: number;
    closedCases: number;
    totalTasks: number;
    lateTasks: number;
    lastUpdatedOn: string;
    averageDaysToCloseCase: number;
    targetDaysToCloseCase: number;
    casesMetGoal: number;
    casesFailedGoal: number;
    goal: number;
    performance: number;
}

export interface Program
{
    id: number;
    version: number;
    name: string;
    description: string;
    active: boolean;
    leader: Leader;
    category: Category;
    organization: Organization;
    isTemplate: boolean;
    createdBy: string;
    ruleSetText: null;
    createdOn: string;
    lastModifiedBy: string;
    lastModifiedOn: string;
    channels: null;
}

export interface Leader
{
    id: number;
    enabled: boolean;
    deleted: boolean;
    deleteImage: boolean;
    username: string;
    name: string;
    lastName: string;
    firstName: string;
    password: null;
    role: string;
    flowablePassword: null;
    email: string;
    departmentName: null;
    organizationName: string;
    department: null;
    organization: Organization;
    inRegistration: boolean;
    servicesAccount: boolean;
    preferredLanguage: string;
    directAddress: null;
    ldap: boolean;
    photo: null;
    phoneNumber: null;
    twoFa: boolean;
    version: number;
    pin: null;
    createdBy: string;
    lastModifiedBy: string;
    lastModifiedOn: string;
    createdOn: string;
    failedLoginAttempts: number;
    selectedLanguage: null;
    fullName: string;
    communityPrograms: any[];
}

export interface Category
{
    id: number;
    name: string;
    active: boolean;
    createdBy: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
}

export interface Website
{
    id: number;
    version: number;
    name: string;
    url: string;
}

export interface WaitTime
{
    id: number;
    version: number;
    locationID: string;
    waitTime: string;
}
